import { KeyValue } from './types/KeyValue';

/**
 * 指定URLへ遷移
 * @param string url URL
 * @return void
 */
export const jumpUrl = (url: string) => {
  if (url) {
    // urlがセットされていれば、そのurl画面に遷移する
    location.href = url;
  }
};

export const addFallBackSource = (sources?: Array<KeyValue>) => {
  const fallbackSource = { key: undefined, value: undefined };
  if (!sources?.length) return [fallbackSource];

  const isAlreadyHaveFallBackSource = sources.some((source) => {
    const sourceValue = source?.value;
    return (
      sourceValue === undefined ||
      sourceValue === null ||
      (typeof sourceValue === 'string' && sourceValue?.trim() === '')
    );
  });
  return isAlreadyHaveFallBackSource ? sources : [fallbackSource, ...sources];
};

export const genUniqueId = (): string => {
  const dateStr = Date.now().toString(36);

  const randomStr = Math.random().toString(36).substring(2, 9);

  return `${dateStr}_${randomStr}`;
};
